import { useState } from 'react'
import { Header } from './Header'
import Footer from './Footer'
import DemograficiSection from './DemograficiSection'
import type { AmbitoId } from '../data/ambitiStats'

export default function CardsPage() {
  const [selectedAmbito, setSelectedAmbito] = useState<AmbitoId | null>(null)

  return (
    <div className="app">
      <Header />
      <div className="app-body">
        <div className="app-content">
          <section className="telemetry-dashboard">
            <div className="telemetry-inner">
              <DemograficiSection
                selectedAmbitoId={selectedAmbito}
                compareAmbiti={false}
                onSelectedAmbitoChange={setSelectedAmbito}
              />
            </div>
          </section>
          <section className="telemetry-dashboard telemetry-dashboard--compare">
            <div className="telemetry-inner">
              <DemograficiSection
                selectedAmbitoId={null}
                compareAmbiti={true}
                onSelectedAmbitoChange={() => {}}
              />
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  )
}
